import { ReactNode } from "react";
import { useIdleReady } from "@/hooks/use-idle-ready";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";

/**
 * Mounts notification/tooltip primitives once the browser is idle. Until then,
 * children render bare — nothing on the homepage triggers a toast or tooltip
 * before LCP, so this keeps their work off the critical path without the
 * fragility of dynamic imports (which can fail with "Importing a module
 * script failed" after dev-server restarts or stale chunks).
 */
export const DeferredUIProviders = ({ children }: { children: ReactNode }) => {
  const ready = useIdleReady(2500);

  if (!ready) return <>{children}</>;

  return (
    <TooltipProvider>
      <Toaster />
      <Sonner />
      {children}
    </TooltipProvider>
  );
};
